import { generatePath } from 'react-router';

import PageUrls from 'Shared/constants/PageUrls.constants';

class PageUrlsUtil {
  static makeUserProfilePageUrl = userSlug => {
    return generatePath(PageUrls.USER_PROFILE_PAGE, { userSlug });
  };

  static makeWorkspaceUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_PAGE, { workspaceId });
  };

  static makeWorkspaceGoalsUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_GOALS_PAGE, { workspaceId });
  };

  static makeWorkspaceHistoryUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_HISTORY_PAGE, { workspaceId });
  };

  static makeWorkspaceHistoryItemsUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_HISTORY_PAGE_ITEMS, { workspaceId });
  };

  static makeWorkspaceHistoryAgendaUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_AGENDA_HISTORY, { workspaceId });
  };

  static makeWorkspaceHistoryAgendaItemUrl = ({ workspaceId, itemUuid }) => {
    return generatePath(PageUrls.WORKSPACE_AGENDA_HISTORY_ITEM_COMMENTS, { workspaceId, itemUuid });
  };

  static makeWorkspaceRelationshipUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_RELATIONSHIP_PAGE, { workspaceId });
  };

  static makeWorkspaceFeedbackUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_FEEDBACK_PAGE, { workspaceId });
  };

  static makeWorkspaceFeedbacItemUrl = (workspaceId, feedbackUuid) => {
    return generatePath(PageUrls.WORKSPACE_FEEDBACK_ITEM_PAGE, { workspaceId, feedbackUuid });
  };

  static makeWorkspacePrivateUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_PRIVATE_PAGE, { workspaceId });
  };

  static makeWorkspaceSettingsUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_SETTINGS, { workspaceId });
  };

  static makeWorkspaceRecognitionRequestNew = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_RECOGNITION_REQUEST_PAGE_NEW, { workspaceId });
  };

  static makeWorkspaceActivitiesUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_ACTIVITIES_PAGE, { workspaceId });
  };

  static makeGoalDetailPageUrl = slug => {
    return generatePath(PageUrls.GOALS_DETAIL_PAGE, { slug });
  };

  static makeGoalDetailPanelUrl = slug => {
    return generatePath(PageUrls.GOALS_DETAIL_PANEL, { slug });
  };

  static makeGoalsPageSlimDetailModalUrl = slug => {
    return generatePath(PageUrls.GOALS_PAGE_MODAL, { slug });
  };

  static makeFeedbackRequestUrl = (workspaceId, feedbackRecognitionRequestId?) => {
    return generatePath(PageUrls.WORKSPACE_FEEDBACK_REQUEST_PAGE, { workspaceId, feedbackRecognitionRequestId });
  };

  static makeWorkspaceMeetingItemUrl = (workspaceId, itemUuid) => {
    return generatePath(PageUrls.WORKSPACE_MEETING_ITEM, { workspaceId, itemUuid });
  };

  static makeWorkspaceMeetingItemCommentsUrl = (workspaceId, itemUuid) => {
    return generatePath(PageUrls.WORKSPACE_MEETING_ITEM_COMMENTS, { workspaceId, itemUuid });
  };

  static makeFeedbackFormUrl = (workspaceId, feedbackRecognitionRequestId?) => {
    return generatePath(PageUrls.WORKSPACE_FEEDBACK_FORM_PAGE, { workspaceId, feedbackRecognitionRequestId });
  };

  static makeEditFeedbackFormUrl = (workspaceId, feedbackUuid) => {
    return generatePath(PageUrls.WORKSPACE_EDIT_FEEDBACK_FORM_PAGE, { workspaceId, feedbackUuid });
  };

  static makeWorkspaceMeetingModeUrl = workspaceId => {
    return generatePath(PageUrls.WORKSPACE_MEETING_MODE, { workspaceId });
  };

  static makeReviewCompilationUrl = reviewSlug => {
    return generatePath(PageUrls.COACHING_360_COMPILATION, { reviewSlug });
  };

  static makePeerReviewFormUrl = formSlug => {
    return generatePath(PageUrls.PEER_REVIEW_FORM, { formSlug });
  };

  static makeReviewShareUrl = reviewSlug => {
    return generatePath(PageUrls.COACHING_360_SHARE, { reviewSlug });
  };

  static makeMeetingItemCommentsUrl = itemUuid => {
    return generatePath(PageUrls.MEETING_ITEM_COMMENTS_PAGE, { itemUuid });
  };

  static makeUpdateAiSettingPageUrl = ({ slug }) => {
    return generatePath(PageUrls.UPDATE_AI_SETTING_PAGE, { slug });
  };

  static makeUpdateAiRportPageUrl = ({ slug }) => {
    return generatePath(PageUrls.UPDATE_AI_REPORT_PAGE, { slug });
  };

  static makeCoachingFeedbackTemplateUrl = ({ slug }) => {
    return generatePath(PageUrls.FEEDBACK_TEMPLATE_BUILD_PAGE, { slug });
  };

  static makeReviewCycleEditUrl = ({ reviewCycleSlug }) => {
    return generatePath(PageUrls.PERFORMANCE_REVIEWS_ADMIN_CYCLES_CYCLE, { reviewCycleSlug });
  };

  static makePerformanceReviewTemplateUrl = ({ slug }) => {
    return generatePath(PageUrls.PERFORMANCE_REVIEWS_TEMPLATE_BUILD_PAGE, { slug });
  };

  static makePerformanceReviewCompilationUrl = ({ reviewSlug }) => {
    return generatePath(PageUrls.PERFORMANCE_REVIEWS_REVIEW, { reviewSlug });
  };

  static makePerformanceReviewShareUrl = ({ reviewSlug }) => {
    return generatePath(PageUrls.PERFORMANCE_REVIEWS_REVIEW_SHARE, { reviewSlug });
  };
}

export default PageUrlsUtil;
